import {
  normalize_text,
  question_key,
  question_required_value,
} from './request_portal_helpers';

function normalized_question_type(question = {}) {
  return normalize_text(question?.question_type).toLowerCase();
}

function compact_question_type(question = {}) {
  return normalized_question_type(question).replace(/\s+/g, '_');
}

function input_type_from_question_type(question_type = '') {
  if (question_type.includes('datetime')) return 'datetime-local';
  if (question_type.includes('date')) return 'date';
  if (question_type.includes('time')) return 'time';
  if (['number', 'integer', 'float', 'decimal', 'currency']
    .some((type) => question_type.includes(type))) return 'number';
  if (question_type.includes('email')) return 'email';
  if (question_type.includes('phone') || question_type.includes('tel')) return 'tel';
  if (question_type.includes('url')) return 'url';
  return 'text';
}

function has_textarea_type(question_type = '') {
  return question_type.includes('long')
    || question_type.includes('text_area')
    || question_type.includes('textarea');
}

export default {
  question_key(question = {}) {
    return question_key(question);
  },
  option_value(option) {
    return option?.choice || option?.label || option?.value || option;
  },
  is_select_question(question = {}) {
    return normalized_question_type(question).includes('select');
  },
  is_multi_select_question(question = {}) {
    return compact_question_type(question).includes('multi_select');
  },
  is_checkbox_question(question = {}) {
    return normalized_question_type(question).includes('checkbox');
  },
  is_radio_question(question = {}) {
    return normalized_question_type(question).includes('radio');
  },
  is_long_text_question(question = {}) {
    return has_textarea_type(normalized_question_type(question));
  },
  is_file_question(question = {}) {
    return ['file', 'upload', 'attachment', 'document', 'facial_verification']
      .some((type) => normalized_question_type(question).includes(type));
  },
  input_type_for_question(question = {}) {
    return input_type_from_question_type(normalized_question_type(question));
  },
  is_question_required(question = {}) {
    return question_required_value(question);
  },
};
